import { makeRequest } from '../../../lib/api';

const USER_PATH = '/v1/users';

class dashboardController {
  getLastUsers = () => {
    return makeRequest('post', `${ USER_PATH }/find`, {
      offset: 0,
      size: 10,
      sortField: 'createdAt',
      sortOrder: 'DESC',
    });
  };
}

export default new dashboardController();
